import apiFetch from '../apiFetch'

export default function (documentId, sheetId, signTypeId, token, dossierId) {
  return apiFetch({ endPoint: `Document/${documentId}/RequestSign?signTypeId=${signTypeId}`, method: 'PUT', token: token, sheetId: sheetId, dossierId: dossierId })
}
